import { render, staticRenderFns } from "./UploadForm.vue?vue&type=template&id=2efe9c60"
import script from "./UploadForm.vue?vue&type=script&lang=js"
export * from "./UploadForm.vue?vue&type=script&lang=js"
import style0 from "./UploadForm.vue?vue&type=style&index=0&id=2efe9c60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports